// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2020":"dd32af54eefce42c","3092":"4d6b1e618289a039","7873":"fc705152bdcb41a0","8778":"e9d470320cf4e142","9468":"fac230b766638f92"}[chunkId] + ".css";
};